export const RECRUIT_COUNT_PER_PAGE = 10
export const RECRUIT_COUNT_PER_PAGE_MOBILE = 15

export const COVER_LETTER_COUNT_PER_PAGE = 10

export const REVIEW_COUNT_PER_PAGE = 17
export const REVIEW_COUNT_PER_PAGE_MOBILE = 25

export const QNA_BLOCK_COUNT_PER_PAGE = 4
export const QNA_BLOCK_COUNT_PER_PAGE_MOBILE = 7

export const QNA_ANSWER_COUNT_PER_BLOCK = 2
export const QNA_ANSWER_COUNT_PER_BLOCK_MOBILE = 1

export const REQUEST_MODAL_DEFAULT_CONTENT = `[기업정보 수정요청]\n\n기업명: \n\n수정 요청 내용:`
